





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser, ILogworkAmountMember } from '@/lib/interfaces';
import { mapState } from 'vuex';
import { ERole } from '@/lib/enums';
import store from '@/store';

@Component({
  computed: mapState(['users']),
})
export default class UserMiniRow extends Vue {
  /** users from vuex */
  public users!: { string: IUser };

  @Prop() private userId!: string;
  @Prop() private amounts!: ILogworkAmountMember;

  private get isOwner(): boolean {
    if (store) {
      const currentUser = store.state.currentUser;
      if (currentUser) {
        return currentUser.roles.includes(ERole.owner);
      }
    }
    return false;
  }

  private get user(): IUser {
    return this.users[this.userId];
  }
}
